var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 18,
    fill: "none",
    viewBox: "0 0 28 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 .5h20A3.5 3.5 0 0 1 27.5 4v10a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 14V4A3.5 3.5 0 0 1 4 .5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E4E7EC",
    d: "M4 .5h20A3.5 3.5 0 0 1 27.5 4v10a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 14V4A3.5 3.5 0 0 1 4 .5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1F71",
    d: "m11 6-2.069 6h-1.35L6.564 7.212c-.062-.295-.115-.403-.303-.528-.307-.203-.815-.392-1.26-.51L5.03 6h2.172c.277 0 .526.224.59.612l.538 3.472L9.658 6zM17.756 10.014c.006-1.532-1.857-1.617-1.844-2.3.003-.209.178-.43.558-.487.19-.027.71-.05 1.3.26l.23-1.23A3.2 3.2 0 0 0 16.768 6c-1.302 0-2.218.789-2.225 1.918-.008.836.654 1.301 1.153 1.58.513.285.686.467.683.72-.003.39-.41.562-.787.57-.662.011-1.047-.205-1.353-.368L14 11.692c.308.161.876.301 1.464.308 1.385 0 2.29-.78 2.294-1.986M21.874 6h-1.189c-.268 0-.493.173-.594.44L18 12h1.463l.29-.896h1.79l.168.896H23zm-1.719 3.875.734-2.253.422 2.253zM14 6l-1.358 6H11l1.358-6z"
  })));
};
export default SvgVisa;